import React from 'react';
import moo from '../assets/SquareLogos/Mutual of Omaha.svg';
import mooDark from '../assets/SquareLogos/Mutual of Omaha Dark.svg';
import aetna from '../assets/SquareLogos/Aetna.svg';
import lbl from '../assets/SquareLogos/Liberty Bankers.svg';
import lblDark from '../assets/SquareLogos/Liberty Bankers Dark.svg';
import prosperity from '../assets/SquareLogos/Prosperity Life.svg';
import prosperityDark from '../assets/SquareLogos/Prosperity Life Dark.svg';
import foresters from '../assets/SquareLogos/Foresters.svg';
import forestersDark from '../assets/SquareLogos/Forsters Financial Dark.svg';
import baltimore from '../assets/SquareLogos/Baltimore Life.svg';
import baltimoreDark from '../assets/SquareLogos/Baltimore Life Dark.svg';
import american from '../assets/SquareLogos/American Amicable.svg';
import americanDark from '../assets/SquareLogos/American Amicable Dark.svg';
import ahl from '../assets/SquareLogos/American Home Life.svg';
import ahlDark from '../assets/SquareLogos/AHL Dark.svg';
import americo from '../assets/SquareLogos/Americo.svg';
import americoDark from '../assets/SquareLogos/Americo Dark.svg';
import rna from '../assets/SquareLogos/Royal Neighbors.svg';
import rnaDark from '../assets/SquareLogos/Royal Neighbors of America Dark.svg';
import gerber from '../assets/SquareLogos/Gerber Life.svg';
import gerberDark from '../assets/SquareLogos/Gerber Dark.svg';
import aig from '../assets/SquareLogos/AIG.svg';
import aigDark from '../assets/SquareLogos/AIG Dark.svg';
import great_western from '../assets/SquareLogos/Great Western.svg';
import cfg from '../assets/SquareLogos/Columbian Financial.svg';
import cfgDark from '../assets/SquareLogos/Columbian Financial Dark.svg';
import transamerica from '../assets/SquareLogos/Transamerica.svg';
import transamericaDark from '../assets/SquareLogos/Transamerica Dark.svg';
import aaa from '../assets/SquareLogos/AAA.svg';
import aaaDark from '../assets/SquareLogos/AAA Dark.svg';
import aarp from '../assets/SquareLogos/AARP.svg';
import aarpDark from '../assets/SquareLogos/AARP Dark.svg';
import colonial_penn from '../assets/SquareLogos/Colonial Penn.svg';
import colonial_pennDark from '../assets/SquareLogos/Colonial Penn Dark.svg';
import ethos from '../assets/Competitors/EthosLife_grey.svg';
import lincoln_heritage from '../assets/SquareLogos/Lincoln Heritage.svg';
import lincoln_heritageDark from '../assets/SquareLogos/Lincoln Heritage Dark.svg';
import nfa from '../assets/SquareLogos/National Family Assurance.svg';
import trustage from '../assets/SquareLogos/Trustage.svg';
import trustageDark from '../assets/SquareLogos/Trustage Dark.svg';
import aflac from '../assets/SquareLogos/Aflac.svg';
import fidelity_life from '../assets/SquareLogos/Fidelity Life.svg';
import fidelity_lifeDark from '../assets/SquareLogos/Fidelity Life Dark.svg';
import globe_life from '../assets/SquareLogos/Globe Life.svg';
import globe_lifeDark from '../assets/SquareLogos/Globe Life Dark.svg';
import gtl from '../assets/SquareLogos/GTL.svg';
import gtlDark from '../assets/SquareLogos/GTL Dark.svg';
import lumico from '../assets/SquareLogos/Lumico.svg';
import physicians_mutual from '../assets/SquareLogos/Physicians Mutual.svg';
import physicians_mutualDark from '../assets/SquareLogos/Physicians Mutual Dark.svg';
import state_farm from '../assets/SquareLogos/State Farm.svg';
import state_farmDark from '../assets/SquareLogos/State Farm Dark.svg';
import usaa from '../assets/SquareLogos/USAA.svg';
import usaaDark from '../assets/SquareLogos/USAA Dark.svg';
import cica from '../assets/SquareLogos/CICA.svg';
import cicaDark from '../assets/SquareLogos/CICA Dark.svg';
import { useTheme } from '../context/ThemeContext';

const CarrierLogo = props => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';
    switch (props.name) {
        case 'Aetna':
          return <img className={props.className} alt="carrier" src={aetna}/>;
        case 'Liberty Bankers Life':
          return <img className={props.className} alt="carrier" src={isDark ? lblDark : lbl}/>;
        case 'Prosperity Life Group':
          return <img className={props.className} alt="carrier" src={isDark ? prosperityDark : prosperity}/>;
        case 'Foresters Financial':
          return <img className={props.className} alt="carrier" src={isDark ? forestersDark : foresters}/>;
        case 'Baltimore Life':
          return <img className={props.className} alt="carrier" src={isDark ? baltimoreDark : baltimore}/>;
        case 'American Amicable':
          return <img className={props.className} alt="carrier" src={isDark ? americanDark : american}/>;
        case 'American Home Life':
          return <img className={props.className} alt="carrier" src={isDark ? ahlDark : ahl}/>;
        case 'Americo':
         return <img className={props.className} alt="carrier" src={isDark ? americoDark : americo}/>;
        case 'Royal Neighbors Of America':
          return <img className={props.className} alt="carrier" src={isDark ? rnaDark : rna}/>;
        case 'Gerber':
          return <img className={props.className} src={isDark ? gerberDark : gerber} alt="carrier"/>;
        case 'AIG':
          return <img className={props.className} alt="carrier" src={isDark ? aigDark : aig}/>;
        case 'Great Western':
          return <img className={props.className} alt="carrier" src={great_western}/>;
        case 'Columbian Financial Group':
          return <img className={props.className} alt="carrier" src={isDark ? cfgDark : cfg}/>;
        case 'Transamerica':
          return <img className={props.className} alt="carrier" src={isDark ? transamericaDark : transamerica}/>;
        case 'AAA':
          return <img className={props.className} alt="carrier" src={isDark ? aaaDark : aaa}/>;
        case 'AARP':
          return <img className={props.className} alt="carrier" src={isDark ? aarpDark : aarp}/>;
        case 'Colonial Penn':
          return <img className={props.className} alt="carrier" src={isDark ? colonial_pennDark : colonial_penn}/>;
        case 'Ethos':
          return <img className={props.className} alt="carrier" src={ethos}/>;
        case 'Lincoln Heritage':
          return <img className={props.className} alt="carrier" src={isDark ? lincoln_heritageDark : lincoln_heritage}/>;
        case 'TruStage':
          return <img className={props.className} alt="carrier" src={isDark ? trustageDark : trustage}/>;
        case 'Lumico':
          return <img className={props.className} alt="carrier" src={lumico}/>;
        case 'Aflac':
            return <img className={props.className} alt="carrier" src={aflac}/>;
        case 'Fidelity Life':
            return <img className={props.className} alt="carrier" src={isDark ? fidelity_lifeDark : fidelity_life}/>;
        case 'Globe Life':
            return <img className={props.className} alt="carrier" src={isDark ? globe_lifeDark : globe_life}/>;
        case 'Guarantee Trust Life':
            return <img className={props.className} alt="carrier" src={isDark ? gtlDark : gtl}/>;
        case 'National Family':
            return <img className={props.className} alt="carrier" src={nfa}/>;
        case 'Physicians Mutual':
            return <img className={props.className} alt="carrier" src={isDark ? physicians_mutualDark : physicians_mutual}/>;
        case 'State Farm':
            return <img className={props.className} alt="carrier" src={isDark ? state_farmDark : state_farm}/>;
        case 'USAA':
            return <img className={props.className} alt="carrier" src={isDark ? usaaDark : usaa}/>;
        case 'CICA':
            return <img className={props.className} alt="carrier" src={isDark ? cicaDark : cica}/>;
        default:
          return <img className={props.className} alt="carrier" src={isDark ? mooDark : moo}/>;
      }
}

export default CarrierLogo;